//bao migrate skip
import baoRouter from "./../../services/bao-router";
window["CheckwareApplicationId"] = "7a392a95-576d-444f-8375-5fea08b153ca";
const Routes = {
    "checkware/folderstructure": {
        url: "Checkware/FolderStructure",
        objectId: "FolderStructure"
    },
    "checkware/eventscriptlog": {
        url: "Checkware/EventEngineLog",
        objectId: "EventEngineLog"
    },
    "checkware/checklist/{folderStructureChecklistId}/:init*:": {
        url: "Checkware/Evaluation",
        replaceRoute: "checkware/evaluation/{id}"
    },
    "checkware/evaluation/{id}": {
        url: "Checkware/Evaluation"
    },
    "checkware/ChecklistEvaluation": {
        url: "Checkware/ChecklistEvaluation",
        objectId: "ChecklistEvaluation"
    },
    "checkware/document/{docid}": {
        url: "BaoDocument"
    },
    "checkware/template/": {
        url: "Checkware/Checklist",
        replaceRoute: "checkware/template/{id}"
    },
    "checkware/template/{id}": {
        url: "Checkware/Checklist"
    },
    "checkware/field/": {
        url: "Checkware/Field",
        replaceRoute: "checkware/field/{id}"
    },
    "checkware/field/{id}": {
        url: "Checkware/Field"
    },
    "checkware/resource/": {
        url: "Checkware/Resource",
        replaceRoute: "checkware/resource/{id}"
    },
    "checkware/resource/{id}": {
        url: "Checkware/Resource"
    },
    "checkware/task/": {
        url: "Checkware/Task",
        replaceRoute: "checkware/task/{id}"
    },
    "checkware/task/{id}": {
        url: "Checkware/Task"
    },
    "checkware/eventscript/": {
        url: "Checkware/EventScript",
        replaceRoute: "checkware/eventscript/{id}"
    },
    "checkware/eventscript/{id}": {
        url: "Checkware/EventScript"
    },
    "checkware/resourcetab/": {
        url: "Checkware/ResourceTab",
        replaceRoute: "checkware/resourcetab/{id}"
    },
    "checkware/resourcetab/{id}": {
        url: "Checkware/ResourceTab"
    },
    "checkware/checklistfieldtab/": {
        url: "Checkware/ChecklistFieldTab",
        replaceRoute: "checkware/checklistfieldtab/{id}"
    },
    "checkware/checklistfieldtab/{id}": {
        url: "Checkware/ChecklistFieldTab"
    },
    "checkware/checklistCategory/": {
        url: "Checkware/ChecklistCategory",
        replaceRoute: "checkware/checklistCategory/{id}"
    },
    "checkware/checklistCategory/{id}": {
        url: "Checkware/ChecklistCategory"
    },
    "checkware/EvaluationConflict": {
        url: "Checkware/EvaluationConflict",
        objectId: "EvaluationConflict"
    },
    "checkware/RegisteredUser": {
        url: "Checkware/RegisteredUser",
        objectId: "RegisteredUser"
    },
    "checkware/MailHistory": {
        url: "Checkware/MailHistory"
    },
    "start": {
        url: "Start",
        closable: false,
        objectId: "Start"
    },
    "dashboard": {
        url: "Dashboard",
        replaceRoute: "dashboard/{id}"
    },
    "dashboard/{id}": {
        url: "Dashboard"
    },
    "dashboard/{id}/{key}": {
        url: "Dashboard"
    },
    "columnprofile": {
        url: "ColumnProfile",
        replaceRoute: "columnprofile/{id}"
    },
    "columnprofile/{id}": {
        url: "ColumnProfile"
    },
    "dataexport": {
        url: "Dataexport",
        objectId: "DataExport"
    },
    "columnprofilefieldstab": {
        url: 'ColumnProfileFieldsTab',
        objectId: 'ColumnProfileFieldsTab'
    },
    "System/{id}": {
        url: "System"
    },
};
baoRouter.addRoutes(Routes);
export default Routes;